import { render } from "./TaskPopup.vue?vue&type=template&id=b729f6c8&ts=true"
import script from "./TaskPopup.vue?vue&type=script&lang=ts"
export * from "./TaskPopup.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__